import { render } from "./Congratulations.vue?vue&type=template&id=6e92a2b3&ts=true"
import script from "./Congratulations.vue?vue&type=script&lang=ts"
export * from "./Congratulations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__